import { useLocation } from "react-use"

export const useProductIdFromUrl = () => {
  const { search } = useLocation()
  const productId =
    new URLSearchParams(search).get("productId") ??
    new URLSearchParams(search).get("productid") ??
    new URLSearchParams(search).get("product_id") ??
    new URLSearchParams(search).get("pid") ??
    ""

  return productId
}
